export const sortOptions = [
  { label: "по совпадению (100 → 0)", value: "DESC" },
  { label: "по совпадению (0 → 100)", value: "ASC" },
];

export const positions = [
  { label: "Продавец-консультант", value: "601" },
  { label: "Мастер-консультант", value: "611" },
];
export const coincidenceList = [
  { label: "25", value: "25" },
  { label: "50", value: "50" },
  { label: "75", value: "75" },
  { label: "100", value: "100" },
];
export const visibleList = ["25", "50", "75"];

export const headerlist = [
  { label: "ФИО", value: "0", style: "table-header-dnm-orange" },
  { label: "Email рабочий", value: "1", style: "table-header-dnm-orange" },
  { label: "Дилерский центр", value: "2", style: "table-header-dnm-orange" },
  { label: "Должность", value: "3", style: "table-header-dnm-orange" },
  { label: "Статус", value: "4", style: "table-header-dnm-orange" },
  { label: null, value: "5", style: "table-right-dnm" },
  { label: null, value: "6", style: "table-left-dnm" },
  { label: "ФИО", value: "7", style: "table-header-dnm-black" },
  { label: "Email рабочий", value: "8", style: "table-header-dnm-black" },
  { label: "Дилерский центр", value: "9", style: "table-header-dnm-black" },
  { label: "Должность", value: "10", style: "table-header-dnm-black" },
  {
    label: "Кол-во рабочих листов/ заказ-нарядов",
    value: "11",
    style: "table-header-dnm-black",
  },
  { label: null, value: "12", style: "table-right-dnm" },
  { label: null, value: "13", style: "table-left-dnm" },
  { label: "Совпадение", value: "14", style: "table-header-dnm-gray" },
];
